import { ValidationResult, useSprintMutation, useSprintQueryClient, SprintMutationResult } from "sprint-common-web";

import { UpdateCloudAssetContentResponse } from "../../../../../../../../common/api/master-api/assets/details/UpdateCloudAssetContentResponse";
import { ValidateCloudAssetContentRequest } from "../../../../../../../../common/api/master-api/assets/details/ValidateCloudAssetContentRequest";
import { useAssetsApi } from "../../../../../../../../common/api/master-api/assets/useAssetsApi";
import { CloudAssetQueryKey } from "../../../../../common/CloudAssetQueryKey";

export interface UseEditCloudAsset {
    validateCloudAssetContent: SprintMutationResult<ValidateCloudAssetContentRequest, ValidationResult>;
    updateCloudAssetContent: SprintMutationResult<ValidateCloudAssetContentRequest, UpdateCloudAssetContentResponse>;
}

export const useEditCloudAssetContent = ({ invalidationKey }: { invalidationKey?: string }): UseEditCloudAsset => {
    const assetsApi = useAssetsApi();
    const sprintQueryClient = useSprintQueryClient();

    const validateCloudAssetContent = useSprintMutation<ValidateCloudAssetContentRequest, ValidationResult>({
        mutationFn: async ({ assetId, contentReference }): Promise<ValidationResult> => {
            if (!assetId) {
                throw new Error("Asset ID is required to validate cloud asset content.");
            }

            return assetsApi.validateCloudAssetContent({ assetId, contentReference });
        }
    });

    const updateCloudAssetContent = useSprintMutation<
        ValidateCloudAssetContentRequest,
        UpdateCloudAssetContentResponse
    >({
        mutationFn: async ({ assetId, contentReference }: ValidateCloudAssetContentRequest) => {
            if (!assetId) {
                throw new Error("Asset ID is required to validate cloud asset content.");
            }

            return assetsApi.updateCloudAssetContent({ assetId, contentReference });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [CloudAssetQueryKey.CloudAssetDetails, invalidationKey]
            });
        }
    });

    return {
        validateCloudAssetContent,
        updateCloudAssetContent
    };
};
